import { render, staticRenderFns } from "./AccountPageSkeleton.vue?vue&type=template&id=2c3f7cf6&scoped=true&"
import script from "./AccountPageSkeleton.vue?vue&type=script&lang=js&"
export * from "./AccountPageSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AccountPageSkeleton.vue?vue&type=style&index=0&id=2c3f7cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f7cf6",
  null
  
)

export default component.exports